
import { FETCH_DOSSIER_REQUEST, FETCH_DOSSIER_SUCCESS, FETCH_DOSSIER_FAILURE } from './actionsTypes';

export const fetchDossierRequest = (token,history) => ({
  type: FETCH_DOSSIER_REQUEST,
  payload: { token,history },
});

export const fetchDossierSuccess = (dossierData) => ({
  type: FETCH_DOSSIER_SUCCESS,
  payload: { dossierData },
});

export const fetchDossierFailure = (error) => ({
  type: FETCH_DOSSIER_FAILURE,
  payload: { error },
});

